<template>
  <div class="wx-open-message-tpl-apply"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="tplInfo">
      <div class="header">
        <el-form size="mini"
                 label-width="72px"
                 label-suffix="：">
          <el-form-item label="模板ID">
            <el-input v-model.trim="form.priTmplId"
                      type="text"
                      maxlength="50"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="body">
        <div class="body-cont"
             v-loading="committing"
             element-loading-text="数据提交中，请稍等...">
          <DataGrid size="mini"
                    height="auto"
                    resizable
                    :data="tplFields">
            <DataGridColumn title="项(kid)"
                            field="kid"
                            width="80"
                            align="center"></DataGridColumn>
            <DataGridColumn title="标题"
                            align="center">
              <template #default="{row}">
                <el-input v-model="row.keyword"
                          size="mini"
                          type="text"
                          maxlength="20"></el-input>
              </template>
            </DataGridColumn>
            <DataGridColumn title="类型"
                            width="120"
                            align="center">
              <template #default="{row}">
                <el-input v-model="row.rule"
                          size="mini"
                          type="text"
                          maxlength="20"></el-input>
              </template>
            </DataGridColumn>
          </DataGrid>
        </div>
      </div>
      <div class="footer">
        <el-button size="mini"
                   type="primary"
                   :disabled="committing"
                   @click="handleApply">提交设置</el-button>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>模板信息加载失败</div>
        <el-button type="text"
                   @click="loadTplInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import DataGrid from '../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../elements/DataGridColumn'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'WxOpenMessageTplApply',
  components: {
    DataGrid,
    DataGridColumn,
    Hint
  },
  props: {
    tpl: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      tplInfo: null,
      form: {
        priTmplId: ''
      },
      committing: false
    }
  },
  computed: {
    tplFields () {
      let tplInfo = this.tplInfo
      if (tplInfo) {
        let fields = tplInfo.fields || []
        let kids = this.tpl.kids || []
        return kids.map(kid => {
          let getKid = `${kid}`
          return fields.find(field => `${field.kid}` === getKid) || {
            kid: getKid
          }
        })
      }
    }
  },
  methods: {
    loadTplInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/message/wx/open/tplInfo',
        method: 'post',
        data: this.$qs.stringify({
          tplCode: this.tpl.code
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.tplInfo = response.data['tplInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleApply () {
      let tplFields = this.tplFields
      if (tplFields) {
        if (!this.form.priTmplId) {
          this.$message.warning('请填写模板ID')
          return
        }
        let isValid = tplFields.every(tplField => {
          if (!tplField.keyword) {
            this.$message.warning(`第${tplField.kid}项标题不能为空`)
            return
          }
          if (!tplField.rule) {
            this.$message.warning(`第${tplField.kid}项类型不能为空`)
            return
          }
          return true
        })
        if (!isValid) {
          return
        }
        this.$confirm('确定要提交类目模板配置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.committing = true
          this.$ajax({
            url: '/workspace/manager/message/wx/open/tplApply',
            method: 'post',
            data: this.$qs.stringify({
              tplCode: this.tpl.code,
              tplApply: JSON.stringify(this.$extend({
                fields: tplFields
              }, this.form))
            })
          }).then(response => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  this.$message.success(response.data['message'])
                  break
                }
                default: {
                  this.$message.warning(response.data['message'])
                  break
                }
              }
            }
          }, () => {
            this.$message.error('请求发送失败，请稍后重试')
          }).finally(() => {
            this.committing = false
          })
        }).catch(() => {})
      }
    }
  },
  mounted () {
    this.loadTplInfo()
  },
  watch: {
    tplInfo (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          this.form[key] = val[key] || ''
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .wx-open-message-tpl-apply {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      padding: 0 15px 0 5px;
      .el-form {
        & > .el-form-item {
          .el-form-item__label {
            color: #909399;
            font-size: 12px;
          }
        }
      }
    }
    & > .body {
      flex: auto;
      position: relative;
      & > .body-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .vxe-table {
          .vxe-table--body-wrapper {
            .vxe-table--body {
              .vxe-body--row {
                .vxe-body--column {
                  .vxe-cell {
                    .el-input {
                      .el-input__inner {
                        text-align: center;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    & > .footer {
      flex: none;
      padding: 15px;
      .el-button {
        width: 100%;
      }
    }
  }
</style>
